<h1 mat-dialog-title>Income Verification Request</h1>

<div mat-dialog-content>
  <div>
    <form [formGroup]="formtaxrequest" autocomplete="nope" style="margin-top: 6px;">

      <span> {{this.yearquestion}} </span>

      <mat-radio-group required id="householdStatus" name="householdStatus" formControlName="householdStatus" required (change)="onChangeEvent($event)"
        class="retrofit-task-radio-group" >
        <mat-radio-button class="retrofit-task-radio-button" hidden></mat-radio-button>
        <mat-radio-button class="retrofit-task-radio-button" value="Single"><span style="white-space:pre-wrap">Single</span></mat-radio-button>
        <mat-radio-button class="retrofit-task-radio-button" value="Qualifying Widow(er) with Dependent Child"><span style="white-space:pre-wrap">Qualifying Widow(er) with Dependent Child</span></mat-radio-button>
        <mat-radio-button class="retrofit-task-radio-button"value="Head of Household"><span style="white-space:pre-wrap">Head of Household</span></mat-radio-button>
        <mat-radio-button class="retrofit-task-radio-button"value="Married Filing Separately"><span style="white-space:pre-wrap">Married Filing Separately</span></mat-radio-button>
        <mat-radio-button class="retrofit-task-radio-button" value="Married Filing Jointly"><span style="white-space:pre-wrap">Married Filing Jointly</span></mat-radio-button>
      </mat-radio-group>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>First Name</mat-label>
        <input matInput autocomplete="off" placeholder="First Name shown on tax return" minlength="1" maxlength="12" id="nameFirst" name="nameFirst" formControlName="nameFirst"
          required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$"/>
        <mat-error *ngIf="formtaxrequest.get('nameFirst').invalid">
          This field is required. No special characters allowed (e.g., @#!%ñ).
        </mat-error>
        <mat-hint *ngIf="formtaxrequest.get('nameFirst').value && formtaxrequest.get('nameFirst').value.length >= 12">
          12 character limit
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Middle Initial</mat-label>
        <input matInput autocomplete="off" placeholder="Middle initial shown on tax return" maxlength="1" id="nameInitial" name="nameInitial" formControlName="nameInitial"
          required="false" pattern="^[a-zA-Z]*$" />
        <mat-error *ngIf="formtaxrequest.get('nameInitial').invalid">
          No special characters allowed (e.g., @#!%ñ).
        </mat-error>
        <mat-hint *ngIf="formtaxrequest.get('nameInitial').value && formtaxrequest.get('nameInitial').value.length >= 1">
          1 character limit
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Last Name</mat-label>
        <input matInput autocomplete="off" placeholder="Last Name shown on tax return" minlength="1" maxlength="22" id="nameLast" name="nameLast" formControlName="nameLast"
          required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$" />
        <mat-error *ngIf="formtaxrequest.get('nameLast').invalid">
          This field is required. No special characters allowed (e.g., @#!%ñ).
        </mat-error>
        <mat-hint *ngIf="formtaxrequest.get('nameLast').value && formtaxrequest.get('nameLast').value.length >= 22">
          22 character limit
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;" *ngIf="data.isMarried">
        <mat-label>Spouse First Name</mat-label>
        <input matInput autocomplete="off" placeholder="Spouse First Name shown on tax return" minlength="1" maxlength="12" id="nameFirstSpouse" name="nameFirstSpouse" formControlName="nameFirstSpouse"
          required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$" />
        <mat-error *ngIf="formtaxrequest.get('nameFirstSpouse').invalid">
          This field is required. No special characters allowed (e.g., @#!%ñ).
        </mat-error>
        <mat-hint *ngIf="formtaxrequest.get('nameFirstSpouse').value && formtaxrequest.get('nameFirstSpouse').value.length >= 12">
          12 character limit
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;" *ngIf="data.isMarried">
        <mat-label>Spouse Middle Initial</mat-label>
        <input matInput autocomplete="off" placeholder="Spouse Middle initial shown on tax return" maxlength="1" id="nameInitialSpouse" name="nameInitialSpouse" formControlName="nameInitialSpouse"
          required="false" pattern="^[a-zA-Z]*$" />
        <mat-error *ngIf="formtaxrequest.get('nameInitialSpouse').invalid">
          No special characters allowed (e.g., @#!%ñ).
        </mat-error>
        <mat-hint *ngIf="formtaxrequest.get('nameInitialSpouse').value && formtaxrequest.get('nameInitialSpouse').value.length >= 1">
          1 character limit
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;" *ngIf="data.isMarried">
        <mat-label>Spouse Last Name</mat-label>
        <input matInput autocomplete="off" placeholder="Spouse Last Name shown on tax return" minlength="1" maxlength="22" id="nameLastSpouse" name="nameLastSpouse" formControlName="nameLastSpouse"
          required="true" pattern="^[a-zA-Z0-9.',\s\'\-]*$" />
        <mat-error *ngIf="formtaxrequest.get('nameLastSpouse').invalid">
          This field is required. No special characters allowed (e.g., @#!%ñ).
        </mat-error>
        <mat-hint *ngIf="formtaxrequest.get('nameLastSpouse').value && formtaxrequest.get('nameLastSpouse').value.length >= 22">
          22 character limit
        </mat-hint>
      </mat-form-field>

      <span class="retrofit-form-text">
        <p [innerHTML]="data.taxrequestmsg" style="overflow-wrap: anywhere;"></p>
      </span>
      <div mat-dialog-actions style="margin-top: 18px !important; float: right !important;">
        <button mat-button (click)="onClickCancel()">
          CANCEL
        </button>
        <button mat-flat-button (click)="onSave()" [disabled]="(formtaxrequest.pristine || formtaxrequest.invalid)" color="primary">
          SAVE
        </button>
      </div>
    </form>
  </div>
</div>
